import { InMemoryCache } from '@apollo/client/cache';
import { ApolloClient, split, createHttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';

const isDevelopment = import.meta.env.MODE === 'development';

// 1. HTTP Link para queries y mutations
const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_URI,
  credentials: 'include',
});

// 2. Auth Link para HTTP
const authLink = setContext((_, { headers }) => {
  const userData = localStorage.getItem('userData');
  if (!userData) return { headers };
  
  const { token } = JSON.parse(userData);
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    }
  };
});

// 3. WebSocket Link para subscriptions
const wsLink = new GraphQLWsLink(
  createClient({
    url: import.meta.env.VITE_GRAPHQL_WS_URI,
    connectionParams: () => {
      const userData = localStorage.getItem('userData');
      if (!userData) return {};
      
      const { token } = JSON.parse(userData);
      return {
        Authorization: `Bearer ${token}`,
      };
    },
    on: {
      connected: () => console.log('🔌 WebSocket connected'),
      error: (error) => console.error('❌ WebSocket error:', error),
      closed: () => console.log('🔌 WebSocket closed'),
    },
  })
);

// 4. Split link: usa wsLink para subscriptions, httpLink para queries/mutations
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  authLink.concat(httpLink)
);

// 5. Cliente Apollo con ambos links
export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
  devtools: {
    enabled: isDevelopment
  }
});

/* import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const isDevelopment = import.meta.env.MODE === 'development'

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_URI,
  credentials: 'include',
});

const authLink = setContext((_, { headers }) => {

  const userData = localStorage.getItem('userData');
  
  if (!userData) return { ...headers }

  const { token } = JSON.parse(userData)
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    }
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
  devtools: {
    enabled: isDevelopment
  }
});
 */